import * as s from './ProgressBar.css';

interface ProgressBarProps {
  /** Completion as a percentage, 0–100. Clamped to that range. */
  percent: number;
  /** Leading label shown above the track (e.g. "Profile complete"). */
  label?: string;
  /** Accessible name for the progress role when no visible label is given. */
  'aria-label'?: string;
  className?: string;
}

/**
 * Slim labelled progress bar — the visual replacement for the "X% complete"
 * Pill. The track fills left-to-right with the verify (green) accent. When a
 * `label` is provided it renders above the track alongside the numeric value.
 */
export function ProgressBar({ percent, label, 'aria-label': ariaLabel, className }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, Math.round(percent)));
  return (
    <div className={[s.wrap, className].filter(Boolean).join(' ')}>
      {label != null && (
        <div className={s.top}>
          <span className={s.label}>{label}</span>
          <span className={s.value}>{clamped}%</span>
        </div>
      )}
      <div
        className={s.track}
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={label == null ? ariaLabel : undefined}
      >
        <div className={s.fill} style={{ width: `${clamped}%` }} />
      </div>
    </div>
  );
}
